module.exports = __webpack_public_path__ + "img/banner-33.175a6d83.jpg";